//@ts-nocheck

// Use this if the elements you need to query are nested more than 1 level deep inside a slot
export const bindAssignedElements = (slotElement:HTMLSlotElement) => {
  // Step 1 - get the assigned elements from the slot
  const assignedElements = slotElement?.assignedElements();

  // Step two - 
  // The function takes a string and checks all the assigned 
  // elements for child elements which matches the selector
  // It will return the first found group of children
  return (selector:string):HTMLElement|NodeListOf<HTMLElement>|null => assignedElements.reduce((match, currentEl) => {

    if (match) return match;
    const possibleMatchingElements = currentEl.querySelectorAll(selector);
    if (possibleMatchingElements.length) {
      return possibleMatchingElements.length > 1 ? possibleMatchingElements : possibleMatchingElements[0]
    } else {
      return null;
    }

  }, null);
}